import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { FlatButton } from 'material-ui'
import Alert from 'react-s-alert'

import MessageTemplateEditorHeader from './MessageTemplateEditorHeader'
import PlainTextEditor from '../../Settings/PlainTextEditor'
import EmailBodyEditor from '../../Settings/EmailBodyEditor'

import classNames from 'classnames/bind'
import styles from '../styles/MessageTemplateEditor.css'

const cx = classNames.bind(styles)

class MessageTemplateEditor extends Component {
  static PropTypes = {
    bodyState: PropTypes.shape({
      getCurrentContent: PropTypes.func.isRequired,
    }),
    closeCreateTemplateModal: PropTypes.func.isRequired,
    handleSave: PropTypes.func.isRequired,
    handleTemplateSelection: PropTypes.func.isRequired,
    isEmail: PropTypes.bool,
    isTemplate: PropTypes.bool,
    isTemplateUpdate: PropTypes.bool,
    subjectState: PropTypes.shape({
      getCurrentContent: PropTypes.func.isRequired,
    }),
    templateName: PropTypes.string,
    templateSettings: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
    updateBodyState: PropTypes.func.isRequired,
    updateSubjectState: PropTypes.func.isRequired,
    updateTemplateName: PropTypes.func.isRequired,
  }

  state = {
    oldBodyState: this.props.bodyState.getCurrentContent(),
    oldSubjectState: this.props.isEmail
      ? this.props.subjectState.getCurrentContent()
      : false,
    textChange: false,
    templateNameChange: false,
  }

  filteredSettings = this.props.templateSettings.filter(item => {
    const messageType = this.props.isEmail ? 'email' : 'text'
    return item.message_type === messageType
  })

  templateNameUpdate = e => {
    const { updateTemplateName, templateName } = this.props
    const { templateNameChange } = this.state
    const newTemplateName = e.target.value
    const templateNameChanged = newTemplateName !== templateName
    if (templateNameChanged && !templateNameChange) {
      this.setState({ templateNameChange: templateNameChanged })
    }
    updateTemplateName(e)
  }

  bodyUpdate = newEditorState => {
    const { updateBodyState } = this.props
    const { textChange, oldBodyState } = this.state
    const newBodyState = newEditorState.getCurrentContent()
    const textChanged = oldBodyState !== newBodyState
    if (textChanged && !textChange) {
      this.setState({ textChange: textChanged })
    }
    updateBodyState(newEditorState)
  }

  subjectUpdate = newEditorState => {
    const { updateSubjectState } = this.props
    const { textChange, oldSubjectState } = this.state
    const newSubjectState = newEditorState.getCurrentContent()
    const subjectChanged = oldSubjectState !== newSubjectState
    if (subjectChanged && !textChange) {
      this.setState({ textChange: subjectChanged })
    }
    updateSubjectState(newEditorState)
  }

  validateTemplate = () => {
    const { bodyState, handleSave, isTemplate } = this.props
    const body = bodyState.getCurrentContent().hasText()
    if (!body) {
      const msg = `Body cannot be blank!`
      return this.handleBodyError(msg)
    }
    return handleSave(isTemplate)
  }

  handleBodyError = msg => {
    Alert.error(msg, {
      position: 'top-right',
      effect: 'jelly',
      timeout: 5000,
      zIndex: 1999,
    })
    return Promise.reject(msg)
  }

  render() {
    const {
      isEmail,
      isTemplateUpdate,
      closeCreateTemplateModal,
      templateName,
    } = this.props
    const isMessageSetting = true
    const { textChange, templateNameChange } = this.state

    const templateModalWrapper = cx('templateModalWrapper')
    const modalBody = cx('modalBody')
    const templateBottomRow = cx('templateBottomRow')

    return (
      <div className={templateModalWrapper}>
        <MessageTemplateEditorHeader
          closeCreateTemplateModal={closeCreateTemplateModal}
          isEmail={isEmail}
          templateNameUpdate={this.templateNameUpdate}
          templateName={templateName}
        />
        <div className={modalBody}>
          <PlainTextEditor
            {...this.props}
            updateBodyState={this.bodyUpdate}
            updateSubjectState={this.subjectUpdate}
          />
          {isEmail && (
            <EmailBodyEditor
              {...this.props}
              updateBodyState={this.bodyUpdate}
              isMessageSetting={isMessageSetting}
            />
          )}
        </div>
        <div className={templateBottomRow}>
          <FlatButton
            label="Cancel"
            onClick={closeCreateTemplateModal}
            style={{ marginRight: '16px' }}
          />
          <FlatButton
            label="Save"
            primary
            onClick={this.validateTemplate}
            disabled={
              isTemplateUpdate
                ? !textChange && !templateNameChange
                : !textChange
            }
          />
        </div>
      </div>
    )
  }
}

export default MessageTemplateEditor



// WEBPACK FOOTER //
// ./src/components/Messages/MessageTemplateEditor/index.js